var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesforceMainImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 576,
    viewBox: "0 0 600 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M527.359 291.028c0 106.506-62.385 156.809-139.298 112.483-76.913-44.326-139.22-166.667-139.22-273.096 0-106.505 62.385-156.808 139.298-112.483 76.913 44.326 139.22 166.59 139.22 273.096z",
    fill: "url(#ztk4tlebla)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M324.822 67.07c-18.257-10.557-36.359-15.99-53.295-16.068-16.859-.078-32.241 5.279-45.216 15.758-12.974 10.48-23.229 25.773-30.221 45.102-6.992 19.33-10.644 42.385-10.644 67.692l139.376 80.267V67.071z",
    fill: "url(#168od7yg9b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.6 152.85c0 38.115 8.158 80.112 23.462 120.634 15.305 40.522 37.059 77.783 62.463 107.049 25.405 29.266 53.451 49.216 80.487 57.367 27.036 8.151 51.819 4.114 71.32-11.644 19.5-15.759 32.707-42.463 38.145-76.697 5.361-34.311 2.642-74.678-7.924-115.976s-28.357-81.742-51.275-116.132c-22.919-34.389-49.8-61.248-77.38-77.084v192.828L216.6 152.85z",
    fill: "url(#ad43qo2fbc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M255.832 133.287 24.627 0l.078 120.323 210.773 121.566 20.432 30.197-.078-138.799z",
    fill: "url(#je88rzibod)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.887V14.206l87.246 50.38v32.682L0 46.888z",
    fill: "#7ECEFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m196.4 128.319-50.654-29.188v10.558l50.654 29.188v-10.558zM196.4 149.512l-97.656-56.28v10.557l97.656 56.28v-10.557zM196.4 170.627 78.078 102.392v10.557L196.4 181.262v-10.635z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.909 146.562c0 9.936 5.904 21.348 13.129 25.54 7.226 4.192 13.13-.466 13.13-10.403 0-9.936-5.904-21.347-13.13-25.539-7.302-4.192-13.129.466-13.129 10.402z",
    fill: "#7ECEFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m348.828 319.518 231.128 133.365.077 120.401L369.26 451.718l-20.355 6.676-.077-138.876z",
    fill: "url(#49d6cpfdde)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512.754 474.075v-32.681L600 491.774v32.682l-87.246-50.381z",
    fill: "#7ECEFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m408.261 383.173 50.654 29.188v10.557l-50.654-29.188v-10.557zM408.261 404.287l91.441 52.709v10.558l-91.441-52.71v-10.557zM408.261 425.48l118.322 68.235v10.557l-118.244-68.235-.078-10.557z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M395.831 386.976c0 9.937-5.904 14.594-13.13 10.403-7.225-4.192-13.129-15.604-13.129-25.54s5.904-14.594 13.129-10.402c7.226 4.192 13.13 15.603 13.13 25.539z",
    fill: "#7ECEFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m186.223 259.899 130.209 75.066V576l-130.209-75.066V259.899z",
    fill: "url(#zg00nerq8f)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m199.042 402.968 104.57 60.317v10.557l-104.57-60.317v-10.557zM206.345 427.809l89.887 51.855v10.558l-89.887-51.856v-10.557z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m244.335 470.892-90.587-52.244v26.937l90.587 52.243v-26.936zM266.166 354.683c0 11.644-6.759 17.155-15.072 12.342-8.313-4.89-15.072-18.242-15.072-29.964 0-11.644 6.759-17.156 15.072-12.343 8.313 4.891 15.072 18.32 15.072 29.965zM251.017 376.419c-13.44-7.84-24.55-.466-26.492 16.38-.311 2.949 1.864 6.831 4.584 8.383l43.817 25.618c2.719 1.552 4.894.31 4.583-3.028-1.942-19.252-13.051-39.512-26.492-47.353z",
    fill: "#7ECEFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m113.738 240.181-33.251-19.174v-11.179l33.251 19.174c2.719 1.553 6.681 4.736 10.022 9.626 3.652 5.201 6.215 11.8 6.215 18.942 0 7.918-2.02 12.42-5.826 13.662-3.574 1.165-7.847-.854-10.411-2.329l-13.673-7.918-.078-.077c-1.165-.699-3.03-1.398-4.506-.932-1.243.388-2.564 1.553-2.564 5.977 0 4.425 1.399 7.065 2.486 8.695 1.399 2.018 3.263 3.415 4.429 4.036l.155.078 41.797 24.142v11.179l-41.564-23.987c-2.874-1.475-6.992-4.658-10.566-9.626-3.884-5.512-6.526-12.421-6.526-20.106 0-7.685 2.642-11.566 6.448-12.653 3.574-1.009 7.692.466 10.566 2.173l13.518 7.841c1.943 1.164 3.419 1.63 4.429 1.32.777-.233 2.175-1.32 2.175-6.987 0-3.726-1.165-6.133-2.331-7.685-1.398-2.096-3.107-3.571-4.195-4.192z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.547 218.601c0 10.014-5.904 14.749-13.13 10.635-7.225-4.192-13.13-15.681-13.13-25.772 0-10.014 5.905-14.75 13.13-10.635 7.225 4.192 13.13 15.758 13.13 25.772zM158.798 317.965c0 10.014-5.905 14.749-13.13 10.635-7.225-4.192-13.129-15.681-13.129-25.773 0-10.014 5.904-14.749 13.129-10.635 7.225 4.192 13.13 15.759 13.13 25.773z",
    fill: "#7ECEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ztk4tlebla",
    x1: 555.318,
    y1: 127.81,
    x2: 297.52,
    y2: 255.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "168od7yg9b",
    x1: 384.064,
    y1: 111.11,
    x2: 228.076,
    y2: 184.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad43qo2fbc",
    x1: 456.791,
    y1: 164.798,
    x2: 342.739,
    y2: 282.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "je88rzibod",
    x1: 205.415,
    y1: 85.082,
    x2: 86.115,
    y2: 178.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "49d6cpfdde",
    x1: 448.131,
    y1: 323.441,
    x2: 477.971,
    y2: 565.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zg00nerq8f",
    x1: 330.347,
    y1: 281.143,
    x2: 214.908,
    y2: 481.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceMainImage);
export default __webpack_public_path__ + "static/media/SalesforceMainImage.6cc3341cc1b625bcdca2d641776b03d8.svg";
export { ForwardRef as ReactComponent };